module.exports = __webpack_public_path__ + "static/media/presente.91b9070c.svg";